<template>
    <div>
        <h1 class="page-title">Taux API Cartes cadeaux</h1>
    </div>
    <div class="card">
        <DataTable
        :value="tableData"
        :rows="rows"
        lazy
        :loading="isLoading"
        :rowsPerPageOptions="rowsPerPageOptions"
        @page="onPaginate"
        :currentPage="currentPage"
        :totalRecords="totalRecords"
        :paginator="true"
        >
        <template #header>
            <div class="search-container">
                <FormKit
                    type="select"
                    label="Rechercher par fournisseur"
                    v-model="supplier"
                    @change="onFilterDt"
                    :options="[
                        {label: '', value: '' },
                        {label: 'API Ogloba', value: '79c5e982-fc65-4345-8aff-39f4226e2b60' }, 
                        {label: 'API BuyBox', value: '858720ea-a85e-4537-a61d-9b7d494cc8d5' },
                        {label: 'API Tillo', value: '8c7a0e96-3299-4b8b-92dc-161675939bcd' },
                    ]"
                />
                <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText
                        class="border-[#656565] border-solid border-[1px] w-full max-w-[300px] p-4	pl-[30px]"
                        v-model.trim="brand"
                        placeholder="Rechercher par marque"
                        @keyup.enter="onFilterDt"
                        @input="onClearInputFilter"
                    />
                    </span>
            </div>
        </template>
        <div>
            <Column field="product_name" header="Nom du produit">
            <template #body="slotProps">
                <span> {{ slotProps.data.productName }} </span>
            </template>
            </Column>
            <Column field="brand" header="Marque">
            <template #body="slotProps">
                <span> {{ slotProps.data.brand }} </span>
            </template>
            </Column>
            <Column field="supplier" header="Fournisseur">
            <template #body="slotProps">
                <span> {{ slotProps.data.supplierName }} </span>
            </template>
            </Column>
            <Column field="status" header="Statut">
            <template #body="slotProps">
                <span> {{ slotProps.data.status }} </span>
            </template>
            </Column>
            <Column field="reduction_value" header="Réduction">
            <template #body="slotProps">
                <span>{{ slotProps.data.reductionValue != null ? slotProps.data.reductionValue + '%' : '' }}</span>
            </template>
            </Column>
            <Column field="b2b_discount_rate" header="Taux Api">
                <template #body="slotProps">
                    <span>{{ displayOglobaRate(slotProps.data.b2bDiscountRate) }}</span>
                </template>
            </Column>
            <Column field="jackpot_min_price" header="Valeur minimale">
            <template #body="slotProps">
                <span> {{ slotProps.data.minPrice }} </span>
            </template>
            </Column>
            <Column field="jackpot_max_price" header="Valeur maximale">
            <template #body="slotProps">
                <span> {{ slotProps.data.maxPrice }} </span>
            </template>
            </Column>
            <Column headerStyle="width: 12em;">
                <template #header>
                    <div>Actions</div>
                </template>
                <template #body="slotProps">
                    <router-link :to="{ name: 'editJackpot', params: { uuid: slotProps.data.variantUuid }}">
                        <Button
                        type="button"
                        icon="pi pi-pencil"
                        title="Éditer"
                        class="p-edition ml-2"
                        >
                        </Button>
                    </router-link> 
                </template>
            </Column>
        </div>
        <template #empty>Aucun résultat trouvé.</template>
        </DataTable>
    </div>
</template>

<script setup lang="ts">
import Button from "primevue/button";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import { ref, onMounted } from 'vue';
import moment from 'moment/moment';
import { IJackpot } from "@/models/product/jackpot/IJackpot";
import { fetchJackpot } from "@/_services/jackpot/jackpot";

const jackpotStartDate = ref<string>('');
const jackpotEndDate = ref<string>('');
const oglobaStartDate = ref<string>('');
const oglobaEndDate = ref<string>('');
const jackpot = Array<IJackpot>();
const tableData = ref<Array<IJackpot>>(jackpot);
const isLoading = ref<boolean>(true);
const rows = ref<number>(30);
const defaultRowsPerPage = 30;
const rowsPerPageOptions = [10, defaultRowsPerPage, 100, 200];
const page = ref<number>(1);
const currentPage = ref<number>(0);
const totalRecords = ref<number>(0);
const brand = ref<string>("");
const supplier = ref<string>("");
const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};
onMounted(async () => {
    await populateDatatable();
});

const onFilterDt = () => {
    rows.value = 30;
    page.value = 1;
    populateDatatable();
};

const onClearInputFilter = () => {
    if (brand.value === "") {
        rows.value = 30;
        page.value = 1;
        populateDatatable();
    }
};

async function populateDatatable() {
    const params = {
        brand: brand.value,
        supplier: supplier.value
    };

    const [loadingDt, totalRecordsDt,tableDataDt] = await fetchJackpot(rows.value, page.value, params);
    isLoading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
    totalRecords.value = totalRecordsDt.value;
}

function calculateFirstDayOfMonth() {
    return moment().startOf('month').format('YYYY-MM-DD');
}

function getTodaysDate() {
    return moment().format('YYYY-MM-DD');
}

function displayOglobaRate(value: any) {
    return value == 'NULL' || !value ? '0%' : value + '%';
}

onMounted(() => {
    jackpotStartDate.value = calculateFirstDayOfMonth();
    jackpotEndDate.value = getTodaysDate();
    oglobaStartDate.value = calculateFirstDayOfMonth();
    oglobaEndDate.value = getTodaysDate();
});
</script>